import _ from 'lodash';

/**
 * Unwraps one field out of a GraphQL result and converts backend failures into thrown errors. Reads the named field from data and throws the first GraphQL error message when that field is nil, or the payload's own message when it is an object carrying isSuccess set to false.
 *
 * @param result - GraphQL result holding data and errors.
 * @param apiName - Field name to read out of the data object.
 * @returns The unwrapped payload of the named field.
 */
const handleErrorApi = (result: any = {}, apiName = '') => {
  const { data, errors } = result;
  const apiData = data[apiName];
  if (_.isNil(apiData) && errors?.length) {
    throw new Error(errors[0].message);
  }
  if (_.isObject(apiData) && 'isSuccess' in apiData && !apiData.isSuccess) {
    throw new Error((apiData as any).message);
  }
  return apiData;
};

export default handleErrorApi;
